import i18n from 'i18next';

export const formatCurrency = (amount, currency, locale = i18n.language) =>
	Number(amount).toLocaleString(locale, { style: 'currency', currency });